/* Native Shopify results; independent of the shared Dawn search controller. */
(() => {
  if (customElements.get('wsc-collection')) return;
  class WscCollection extends HTMLElement {
    connectedCallback() {
      this.classList.add('is-enhanced');
      this.onClick = this.handleClick.bind(this);
      this.onChange = this.handleChange.bind(this);
      this.onSubmit = this.handleSubmit.bind(this);
      this.onPop = () => { this.closeSheet(); this.load(new URL(location.href), false, false); };
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('submit', this.onSubmit);
      window.addEventListener('popstate', this.onPop);
      this.setup();
    }
    disconnectedCallback() {
      this.cancelRequest();
      window.removeEventListener('popstate', this.onPop);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('submit', this.onSubmit);
    }
    setup() {
      this.setProductAudienceLinks();
      this.dialog = this.querySelector('dialog');
      this.querySelector('[data-open-filters]').setAttribute('aria-haspopup', 'dialog');
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.closeSheet(); });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.querySelector('[data-open-filters]')?.focus({ preventScroll: true });
      });
      this.syncHiddenContext();
    }
    setProductAudienceLinks() {
      const handle = location.pathname.match(/\/collections\/([^/]+)/)?.[1] || '';
      const family = handle.split('-')[0];
      const audience = family === 'mens' ? 'men' : family === 'womens' ? 'women' : '';
      this.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return;
        if (audience) url.searchParams.set('wsc_audience', audience);
        else url.searchParams.delete('wsc_audience');
        link.href = url.pathname + url.search + url.hash;
      });
    }
    syncHiddenContext() {
      // Preserve market, sorting and authenticated Shopify draft arguments on native GET too.
      const params = new URL(location.href).searchParams;
      this.querySelectorAll('[data-filter-form]').forEach(form => {
        for (const [key, value] of params) {
          if (key.startsWith('filter.') || key === 'page' || key === 'section_id' || key === 'sort_by') continue;
          const input = document.createElement('input');
          input.type = 'hidden'; input.name = key; input.value = value; form.append(input);
        }
      });
    }
    cancelRequest() {
      this.sequence = (this.sequence || 0) + 1;
      this.request?.abort();
      this.removeAttribute('aria-busy');
    }
    formUrl(form) {
      const min = form.querySelector('[name="filter.v.price.gte"]');
      const max = form.querySelector('[name="filter.v.price.lte"]');
      max?.setCustomValidity('');
      if (min?.value && max?.value && Number(min.value) > Number(max.value)) {
        max.setCustomValidity('Maximum price must be at least the minimum price.');
      }
      if (!form.reportValidity()) return null;
      const url = new URL(location.href);
      for (const key of [...url.searchParams.keys()]) {
        if (key.startsWith('filter.') || key === 'page' || key === 'sort_by') url.searchParams.delete(key);
      }
      for (const [key, value] of new FormData(form)) {
        if (value !== '' && (key.startsWith('filter.') || key === 'sort_by')) url.searchParams.append(key, value);
      }
      url.searchParams.delete('section_id');
      return url;
    }
    handleSubmit(event) {
      const form = event.target.closest('[data-filter-form]');
      if (!form || form.dataset.filterForm === 'mobile-fallback') return;
      event.preventDefault();
      const url = this.formUrl(form);
      if (url) this.load(url, form.dataset.filterForm === 'mobile', true);
    }
    handleChange(event) {
      const target = event.target;
      if (target.closest('[data-filter-form="mobile-fallback"]')) return;
      if (target.matches('[data-sort]')) {
        const url = new URL(location.href); url.searchParams.set('sort_by', target.value); url.searchParams.delete('page');
        this.load(url, false, true); return;
      }
      if (target.matches('[data-mobile-sort]')) this.dialog.querySelector('[name="sort_by"]').value = target.value;
      const form = target.closest('[data-filter-form]') || (target.matches('[data-mobile-sort]') && this.dialog.querySelector('form'));
      if (!form) return;
      const mobile = form.dataset.filterForm === 'mobile';
      if (mobile) { this.staged = null; this.dialog.querySelector('[data-apply]').disabled = true; }
      const url = this.formUrl(form);
      if (url) this.load(url, mobile, true);
    }
    collectionUrl(href, clear, material = '') {
      const current = new URL(location.href);
      const url = new URL(href, current);
      for (const [key, value] of current.searchParams) {
        if (key === 'page' || key === 'section_id') continue;
        if (clear && key.startsWith('filter.')) continue;
        if (!clear && material && key === 'filter.p.m.custom.filter_material' && value === material) continue;
        // Preserve repeated facet values, sorting, market and draft arguments.
        if (key.startsWith('filter.')) {
          if (!url.searchParams.getAll(key).includes(value)) url.searchParams.append(key, value);
        } else url.searchParams.set(key, value);
      }
      return url;
    }
    navigateCollection(url) {
      location.assign(url.href);
    }
    handleClick(event) {
      if (event.target.closest('[data-filter-form="mobile-fallback"]')) return;
      const target = event.target.closest('button, a, [data-open-filters]');
      if (!target) return;
      if (target.matches('[data-open-filters]')) {
        // Preserve a native fallback already opened while the script was loading.
        if (target.parentElement.matches('details[open]')) return;
        event.preventDefault();
        this.cancelRequest();
        this.staged = null;
        this.mobileOriginal = this.dialog.querySelector('[data-mobile-facets]').innerHTML;
        this.dialog.querySelector('form').reset();
        this.dialog.querySelector('[data-mobile-sort]').value = this.querySelector('[data-sort]').value;
        this.dialog.querySelector('[data-apply]').disabled = false;
        this.dialog.querySelector('[data-apply]').textContent = `Show ${this.dataset.count} products`;
        this.dialog.querySelector('[data-mobile-error]').hidden = true;
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal(); return;
      }
      if (target.matches('[data-cancel]')) { this.closeSheet(); return; }
      if (target.matches('[data-apply]')) {
        if (this.staged) {
          const { node, url } = this.staged; this.closeSheet(); this.commit(node, url, true);
        } else this.closeSheet();
        return;
      }
      if (target.matches('[data-category-toggle], [data-category-link], [data-clear-collection]')) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const clear = target.matches('[data-clear-collection]');
        const url = this.collectionUrl(target.href, clear, target.dataset.categoryMaterial);
        if (url.pathname === location.pathname) this.load(url, false, true);
        else this.navigateCollection(url);
        return;
      }
      if (target.matches('[data-mobile-clear]')) {
        if (target.dataset.categoryActive === 'true') {
          this.navigateCollection(this.collectionUrl(target.dataset.resetUrl, true));
          return;
        }
        const form = this.dialog.querySelector('form');
        form.querySelectorAll('input[type="checkbox"]').forEach(input => { input.checked = false; });
        form.querySelectorAll('input[type="number"]').forEach(input => { input.value = ''; input.setCustomValidity(''); });
        const url = this.formUrl(form); if (url) this.load(url, true, true); return;
      }
      if (target.matches('[data-filter-link], [data-clear]')) {
        // Keep normal modified-click/new-tab semantics.
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const url = new URL(target.href);
        const current = new URL(location.href);
        for (const [key, value] of current.searchParams) {
          if (!key.startsWith('filter.') && key !== 'page' && key !== 'section_id') url.searchParams.set(key, value);
        }
        this.load(url, false, true);
      }
    }
    closeSheet() {
      this.cancelRequest(); this.staged = null;
      if (this.mobileOriginal != null) this.dialog.querySelector('[data-mobile-facets]').innerHTML = this.mobileOriginal;
      this.mobileOriginal = null;
      if (this.dialog.open) this.dialog.close();
    }
    uiState(scope) {
      return {
        open: [...scope.querySelectorAll('details')].map(el => [el.dataset.facet || 'intro', el.open]),
        focus: scope.contains(document.activeElement) ? document.activeElement.id : null
      };
    }
    restoreUi(scope, state) {
      state.open.forEach(([key, open]) => {
        const el = key === 'intro' ? scope.querySelector('[data-intro]') : [...scope.querySelectorAll('[data-facet]')].find(el => el.dataset.facet === key);
        if (el) el.open = open;
      });
      if (state.focus) document.getElementById(state.focus)?.focus({ preventScroll: true });
    }
    async load(url, mobile, push) {
      this.cancelRequest();
      const sequence = this.sequence;
      this.request = new AbortController();
      const controller = this.request;
      const timeout = setTimeout(() => controller.abort('timeout'), 15000);
      const apply = this.dialog.querySelector('[data-apply]');
      if (mobile) { this.staged = null; apply.disabled = true; apply.textContent = 'Updating…'; }
      else this.setAttribute('aria-busy', 'true');
      this.querySelector('.wsc-filter-error').hidden = true;
      this.dialog.querySelector('[data-mobile-error]').hidden = true;
      try {
        const requestUrl = new URL(url); requestUrl.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(requestUrl, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const node = doc.getElementById(this.id);
        if (!node || !node.querySelector('[data-results]')) throw new Error('Incomplete results');
        if (sequence !== this.sequence) return;
        if (mobile) {
          const holder = this.dialog.querySelector('[data-mobile-facets]');
          const state = this.uiState(holder);
          holder.innerHTML = node.querySelector('[data-mobile-facets]').innerHTML;
          this.restoreUi(holder, state);
          this.staged = { node, url };
          apply.disabled = false; apply.textContent = `Show ${node.dataset.count} products`;
        } else this.commit(node, url, push);
      } catch (error) {
        if (sequence !== this.sequence) return;
        const errorBox = mobile ? this.dialog.querySelector('[data-mobile-error]') : this.querySelector('.wsc-filter-error');
        errorBox.hidden = false; errorBox.querySelector('a').href = url.href;
        if (mobile) { apply.disabled = true; apply.textContent = 'Unable to update'; }
      } finally {
        clearTimeout(timeout);
        if (sequence === this.sequence) this.removeAttribute('aria-busy');
      }
    }
    commit(node, url, push) {
      const state = this.uiState(this.querySelector('.wsc-desktop-filters'));
      const introOpen = this.querySelector('[data-intro]')?.open;
      const focusedSort = document.activeElement?.matches('[data-sort]');
      const fromMobile = document.activeElement?.matches('[data-open-filters]');
      this.innerHTML = node.innerHTML; this.dataset.count = node.dataset.count;
      if (push && url.href !== location.href) history.pushState({}, '', url);
      this.setup();
      this.restoreUi(this.querySelector('.wsc-desktop-filters'), state);
      if (this.querySelector('[data-intro]')) this.querySelector('[data-intro]').open = !!introOpen;
      if (focusedSort) this.querySelector('[data-sort]').focus({ preventScroll: true });
      if (fromMobile) this.querySelector('[data-open-filters]').focus({ preventScroll: true });
    }
  }
  customElements.define('wsc-collection', WscCollection);
})();
